import React from 'react';

import { T8y } from 'ui';

export const Meta12 = () => {
  return (
    <div>
      <T8y as="h1" center bold mb2>
        12 Yard Skip
      </T8y>
      <T8y as="h2" center mb2>
        For Major Renovations and Commercial Use
      </T8y>
      <T8y as="p" center mb3>
        Our 12-yard skip is designed for major renovations and substantial
        commercial projects. It accommodates large volumes of mixed waste
        materials, making it an efficient choice for extensive works.
      </T8y>
      <T8y as="h3" center mb2>
        When to Opt for a 12 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Large construction and demolition projects <br />
        Industrial site clearances <br />
        Bulk waste disposal requirements <br />
        Significant landscaping projects <br />
      </T8y>
      <T8y as="h3" center mb2>
        Benefits of a 12 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        High Volume Capacity: Ideal for heavy and bulky waste. <br />
        Efficient: Handles large clearances in one go. <br />
        Professional Solution: Meets the demands of sizable projects. <br />
        Environmentally Friendly: We ensure responsible disposal and recycling.{' '}
        <br />
      </T8y>
      <T8y as="h4" center mb2>
        How to Book a 12 Yard Skip Hire
      </T8y>
      <T8y as="p" center mb5>
        Get in touch to discuss your project needs. We'll assist with logistics,
        including any necessary permits and scheduling, to ensure a smooth and
        compliant waste management process.
      </T8y>
    </div>
  );
};
